type CountryOption = { value: string; label: string };

export enum Country {
  Norge = "Norge",
  Sverige = "Sverige",
  Danmark = "Danmark",
}

export const countryToOption = (country: Country): CountryOption => {
  return ({
    value: country.toString(),
    label: country.toString(),
  } as CountryOption);
};

export const countryOptions: CountryOption[] = Object.values(Country).map((country) => {
  return countryToOption(country);
});